import de from "date-fns/locale/de";
import en from "date-fns/locale/en-US";
import DatePicker, { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import "./date-picker.scss";

// Register available locales
registerLocale("de", de);
registerLocale("en", en);

function DatePickerAtom(props) {
	const {
		className = "",
		placeholder,
		value,
		onChange,
		error = "",
		dateFormat = "dd.MM.yyyy",
		label,
		required = false,
		disabled = false,
		...rest
	} = props;

	const { t, i18n } = useTranslation();

	// Get current locale from i18n
	const currentLocale = i18n.language.substring(0, 2).toLowerCase();

	// Use a supported date-fns locale or fallback to "de"
	const pickerLocale = ["de", "en"].includes(currentLocale) ? currentLocale : "de";

	// Configure popper for optimal positioning
	const popperProps = {
		strategy: "fixed",
		modifiers: [
			{
				name: "offset",
				options: {
					offset: [0, 10],
				},
			},
			{
				name: "preventOverflow",
				options: {
					boundary: "viewport",
					padding: 8,
				},
			},
			{
				name: "flip",
				options: {
					fallbackPlacements: ["top", "bottom", "right", "left"],
					behavior: ["flip"],
				},
			},
			{
				name: "eventListeners",
				options: {
					scroll: true,
					resize: true,
				},
			},
		],
	};

	return (
		<div
			className={`date-picker-wrapper${disabled ? " date-picker-wrapper--disabled" : ""}`}
		>
			{label ? (
				<label>
					{label}
					{required && <span className="text-danger"> *</span>}
				</label>
			) : null}
			<DatePicker
				locale={pickerLocale}
				className={className || "form-control"}
				placeholderText={required ? `${placeholder || ""} *` : placeholder}
				selected={value}
				onChange={onChange}
				dateFormat={dateFormat}
				disabled={disabled}
				popperProps={popperProps}
				popperPlacement="bottom-start"
				{...rest}
			/>
			{error ? <p className="text-danger">{t(error)}</p> : ""}
		</div>
	);
}

export default DatePickerAtom;
